import { FC } from "react";
import { Trans } from "@lingui/macro";
import {
  StyledDropDownHeader,
  SizeGuideLabel,
} from "./SmallSizeGuideHeader.styled";
import { Text } from "@otrium/atoms";
import { RullerLengthIcon } from "@otrium/icons";
import { FlexProps } from "@otrium/core";

type StyledHeaderProps = Omit<FlexProps, "css">;

interface Props extends StyledHeaderProps {
  onOpenSizeGuide?: () => void;
}

const SmallSizeGuideHeader: FC<Props> = ({ onOpenSizeGuide, ...rest }) => {
  return (
    <StyledDropDownHeader {...rest}>
      <RullerLengthIcon width="24px" height="24px" />
      <Text variant="body.source.semibold14">
        <span>
          <Trans>pdp_size_fits_small_info</Trans>
          &nbsp;
        </span>
        <SizeGuideLabel onClick={onOpenSizeGuide}>
          <Trans>View size guide</Trans>
        </SizeGuideLabel>
      </Text>
    </StyledDropDownHeader>
  );
};

export default SmallSizeGuideHeader;
